module.exports = __webpack_public_path__ + "static/img/AF.ca11e351.svg";